import { Slide } from "@jelly/lesson";

import theory from "../../theory";

import forest from "./components/forest";
import houseInterior from "./components/house-interior";
import seashore from "./components/seashore";
import townGarden from "./components/town-garden";
import applause from "./components/applause";
import stormInACar from "./components/storm-in-a-car";
import spanishProcession from "./components/spanish-procession";
import boatHorn from "./components/boat-horn";

const principle: Slide = {
  description:
    "The dB scale is a non linear scale depicting the acoustic level and where +3 dB (+10 dB) is equivalent to have multiply by 2 (10) the pressure amplitude. To have a better understanding of this scale, it is here proposed, after a preliminary setup of your volume, to travel along the dB scale! First, click on the “preliminary setting” button and set your volume such that you barely hear the beep (~20 dB SPL). Once this is set, select the dB scale or sound landscape and listen to the different level!",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "layout",
        data: {
          type: "table",
          options: {
            cols: 1,
            rows: 2,
            rowsSize: [0.5, 3],
            components: [
              [
                {
                  variant: "blockContainer",
                  data: {
                    block: {
                      type: "text",
                      options: {
                        data: "<b>Sound landscape</b>",
                        scrollbars: false,
                        formatter: "html",
                      },
                    },
                    styles: {
                      textTransform: "uppercase",
                      letterSpacing: "0.25em",
                      alignItems: "flex-end",
                      paddingBottom: "1%",
                      fontWeight: 800,
                    },
                  },
                },
              ],
              [
                {
                  variant: "layout",
                  data: {
                    type: "slidersToggle",
                    options: {
                      labels: [
                        [
                          { name: "Forest</br>(30 dB SPL)" },
                          { name: "House interior</br>(40 dB SPL)" },
                          { name: "Seashore</br>(50 dB SPL)" },
                          { name: "Town garden</br>(60 dB SPL)" },
                          { name: "Applause</br>(70 dB SPL)" },
                          { name: "Storm in a car</br>(80 dB SPL)" },
                          { name: "Spanish</br>procession</br>(90 dB SPL)" },
                          { name: "Boat Horn</br>(100 dB SPL)" },
                        ],
                      ],
                      components: [
                        forest,
                        houseInterior,
                        seashore,
                        townGarden,
                        applause,
                        stormInACar,
                        spanishProcession,
                        boatHorn,
                      ],
                    },
                  },
                },
              ],
            ],
          },
        },
      },
    },
    styles: {
      padding: "0px 5% 2% 0%",
    },
  },
};

export default principle;
